// extracted by mini-css-extract-plugin
export default {"container":"OI-z","header":"PI-z","details":"QI-z","link":"RI-z"};